import { ISaveUserRequest } from "common/interfaces/apiRequest/SaveUserRequest";
import { IUpdateUserRequest } from "common/interfaces/apiRequest/IUpdateUserRequest";
import { IADUser } from "common/interfaces/IADUser";
import { IUser } from "common/interfaces/IUser";
import { IWorkflow } from "common/interfaces/IWorkflow";
import { UserApi } from "core/api/UserApi";
import { WorkflowApi } from "core/api/WorkflowApi";
import { action, makeAutoObservable, observable, runInAction } from "mobx";

export class WorkflowStore {
    @observable public workflows: IWorkflow[] = [];
    @observable public selectedWorkflow: IWorkflow = {};

    @observable public isWorkflowOperation: boolean = false;
    @observable public workflowOperationMessage: string = "";
    @observable public messageVariant: any = "";

    constructor() {
        makeAutoObservable(this);
        //this.getAllWorkflows();
    }

    @action public clearUserOperationFlags() {
        runInAction(() => {
            this.isWorkflowOperation = false;
            this.workflowOperationMessage = "";
            this.messageVariant = "";
        });
    }

    @action
    public async getAllWorkflows(): Promise<any> {
        return WorkflowApi.getWorkflows();
    }

    @action
    public async saveWorkflow(saveWorkflowRequest: IWorkflow): Promise<any> {
        return WorkflowApi.saveWorkflow(saveWorkflowRequest);
        // runInAction(() => {
        //     if (response.success == true) {
        //         this.isWorkflowOperation = true;
        //         this.workflowOperationMessage = `Wokflow ${saveWorkflowRequest.name} created successfully`;
        //         this.messageVariant = "success";
        //     } else {
        //         this.isWorkflowOperation = true;
        //         this.workflowOperationMessage = `Wokflow ${saveWorkflowRequest.name} could not be created`;
        //         this.messageVariant = "error";
        //     }
        // });
        // return response;
    }

    @action
    public async updateWorkflow(updateWorkflowRequest: IWorkflow): Promise<any> {
        return WorkflowApi.updateWorkflow(updateWorkflowRequest);
        // runInAction(() => {
        //     if (response.success == true) {
        //         this.isWorkflowOperation = true;
        //         this.workflowOperationMessage = `Workflow ${updateWorkflowRequest.name} updated successfully`;
        //         this.messageVariant = "success";
        //     } else {
        //         this.isWorkflowOperation = true;
        //         this.workflowOperationMessage = `Workflow ${updateWorkflowRequest.name} could not be updated`;
        //         this.messageVariant = "error";
        //     }
        // });
        // return response;
    }

    @action
    public async getWorkflowById(workflowId: number) {
        var response = await WorkflowApi.getWorkflowById(workflowId);
        runInAction(() => {
            this.selectedWorkflow = response.workflow;
        });
    }

    @action
    public async deletetWorkflowById(workflowId: number): Promise<any> {
        await WorkflowApi.deleteWorkflowById(workflowId);
    }

    @action public async resetSelectedWorkflow() {
        this.selectedWorkflow = {};
    }
}
